<template>
  <div>
    <div class="popstyle" v-bind:style="{display:parsedLocalizado}">
      <b-modal class="fixedModal" ref="myModal" size="lg" id="modal1" :title="modalTitle" centered :hide-footer="true"
               @hidden="onHidden">
        <div v-if="loadingFeatures || loadingDetails">
          <Loader :delay="0"></Loader>
        </div>
        <div v-else>
          <template v-if="!details">
            <div v-if="parsedFeatures.length>0" class="scroll">
              <b-table
                striped hover
                :items="parsedFeatures"
                :fields="table_fields">
                <span slot="desc" slot-scope="data" v-html="data.item.desc"></span>
                <template slot="actions" slot-scope="row">
                  <b-button v-if="!row.item.catastro" @click="showDetails(row.item)">Ver</b-button>
                  <a v-else :href="row.item.url" class="btn btn-secondary" target="_blank">Ver</a>
                </template>
              </b-table>
            </div>
            <div v-else>
              {{ message }}
            </div>
          </template>
          <div v-else>
            <!-- TODO refactor -> localizar and details is used in LotesList.vue -->
            <b-row>
              <b-col>
                <b-button v-if="parsedFeatures.length>1" variant="link" @click="noDetails"><i class="fa fa-arrow-left"
                                                                                              style="padding-left: 0em;"></i>
                  Atrás
                </b-button>
              </b-col>
              <b-col class="text-right">
                <b-button @click="localizar">Localizar</b-button>
                <b-button v-if="isTerritory && selectarea" class="ml-4" @click="selectArea">Aceptar</b-button>
              </b-col>
            </b-row>
            <Details @close="close" @comercialSaved="comercialSaved" @calderaSaved="calderaSaved" ref="details"
                     :feature="details" :permisos="permisos"></Details>
          </div>
        </div>
      </b-modal>
    </div>
    <div v-if="localizado" class="absoluteButton">
      <b-button v-if="change" @click="saveLocation">Guardar</b-button>
      <b-button @click="atras">Atras</b-button>
    </div>
  </div>
</template>

<style>

</style>

<script>
import Details from './Details.vue';
import Loader from '@/components/Layout/Loader.vue';

export default {
  name: 'PopUp',
  props: ['clickEvent', 'ComercialTypes', 'permisos', 'selectarea'],
  components: {Details, Loader},
  data () {
    return {
      interval: null,
      change: false,
      loadingFeatures: true,
      localizado: false,
      parsedFeatures: [],
      loadingDetails: false,
      message: '',
      details: false,
      features: [],
      idCalderasCentralizadas: [],
      modalTitle: 'Seleccione elemento',
      table_fields: [
        {key: 'tipo_name', label: 'Tipo'},
        {key: 'desc', label: 'Descripción'},
        {key: 'actions', label: 'Ver'}
      ],
      isTerritory: false,
      territorieslayer: [],
      geometry: null
    };
  },
  computed: {
    parsedLocalizado: function () {
      if (this.localizado) {
        return 'none';
      } else {
        return 'block';
      }
    }
  },
  mounted: async function () {
    this.$refs.myModal.show();
    this.territorieslayer = this.$parent.map.layers.find(l => l.name === 'Territorio').layers.filter(l => l.hasOwnProperty('territoriogn')).map(l => l.layer_name.split(':')[1]);

    // document.getElementsByClassName('kernel-map')[0].style.cursor = 'wait'
    this.features = [];

    const layersList = [];
    let layersCatastro = false;
    const cqlList = [];
    let l = [];

    // Get active layers (available for consulting)
    for (let index = 0; index < this.$parent.map.layers.length; index++) {
      const group = this.$parent.map.layers[index];
      // if (group.active && this.hasPermision(group, 'C')) {
      let layers = [];
      if (group.name === 'Territorio') {
        if (this.permisos['TERRITORIO GN']['C']) {
          layers = group.layers.filter(l => l.territoriogn);
        }

        if (this.permisos['TERRITORIO NO GN']['C']) {
          layers = layers.concat(group.layers.filter(l => !l.territoriogn));
        }
      } else if (this.hasPermision(group, 'C')) {
        if (group.layers) {
          layers = group.layers;
        }
      }

      for (let index2 = 0; index2 < layers.length; index2++) {
        const layer = layers[index2];
        if (layer.active) {
          if (layer.catastro) {
            layersCatastro = true;
            continue; // La capa catastro no tiene filtros
          } else {
            if (layer.query_layer_name) {
              layersList.push(layer.query_layer_name);
            } else {
              layersList.push(layer.layer_name);
            }
          }
          // CQL filter
          l = [];
          if (layer.filter) {
            for (let index = 0; index < Object.keys(layer.filter).length; index++) {
              const key = Object.keys(layer.filter)[index];
              const value = layer.filter[key];
              if (value.constructor === Array) {
                l.push(key + ' IN (' + value.toString() + ')');
              } else {
                l.push(key + '=' + value);
              }
            }
          }
          if (l.length === 0) {
            l = ['create_date is not null'];
          }
          cqlList.push(l.join(' AND '));
        }
      }
    }

    // Comercial y caldera
    for (let index = 0; index < ['comercial', 'caldera'].length; index++) {
      const element = ['comercial', 'caldera'][index];

      if ((this.$parent.$refs.navbar[element].active || this.$parent.$refs.navbar[element].indeterminate) && this.hasPermision(element, 'C')) {
        layersList.push(this.$parent.$refs.navbar[element].layer_name);

        l = this.$parent.getArrayCql(this.$parent.$refs.navbar[element]);
        if (l.length === 0) {
          l = ['create_date is not null'];
        }
        cqlList.push(l.join(' AND '));
      }
    }

    // Recuperamos las features que coincidan con el punto clicado por el usuario
    try {
      // Obtenemos las feauture que puedan pertanecer a las capas WMS y del catastro si estuviera seleccionada
      if (layersCatastro) {
        const features = await Promise.all([this.getFeatureWMS(layersList, cqlList), this.getFeaturesCatastro()]);
        this.features = features.flat();
      } else {
        this.features = await this.getFeatureWMS(layersList, cqlList);
      }

      // Cargamos los detalles
      this.loadingFeatures = false;
      this.getDetailsIfLoaded();
    } catch (error) {
      console.error(error);
      this.message = error;
      this.loadingFeatures = false;
    }
  },
  methods: {
    calcParsedFeatures (cb) {
      var list = [];
      var tmpType = null;
      for (let index = 0; index < this.features.length; index++) {
        const feature = this.features[index];
        var newFeature = feature;

        if (feature.catastro) {
          newFeature.tipo_name = 'Parcela catastro';
          newFeature.desc = feature.code;
        } else {
          var tmp = feature.id.split('.')[0];
          if (tmp === 'red') {
            newFeature.tipo_name = 'Subtramo Red';
            newFeature.desc = feature.properties.presoper + ' ' + feature.properties.amp_status_subtramo_red;
          } else if (tmp === 'red_inyeccion') {
            newFeature.tipo_name = 'Red inyección biogás';
            newFeature.desc = feature.properties.presoper + ' ' + feature.properties.amp_status_subtramo_red;
          } else if (tmp === 'municipio') {
            newFeature.tipo_name = 'Municipio';
            newFeature.desc = feature.properties.nombre_municipio_ine + ' (' + feature.properties.codigo_municipio_ine + ')';
          } else if (tmp === 'provincia') {
            newFeature.tipo_name = 'Provincia';
            newFeature.desc = feature.properties.nombre_provincia_ine + ' (' + feature.properties.codigo_provincia_ine + ')';
          } else if (tmp === 'acometida') {
            newFeature.tipo_name = 'Acometida';
            newFeature.desc = feature.properties.codacom;
          } else if (tmp === 'gasinera') {
            newFeature.tipo_name = 'Gasinera';
            newFeature.desc = feature.properties.denominacion;
          } else if (tmp === 'plantas_glp' || tmp === 'plantas_gnl') {
            newFeature.tipo_name = 'Planta de gasificacion';
            newFeature.desc = feature.properties.descripcion + ' (' + feature.properties.nombre_municipio_ine + ')';
          } else if (tmp === 'zona_gn') {
            newFeature.tipo_name = 'Zona NEDGIA';
            newFeature.desc = 'Zona ' + feature.properties.nombre_zona_gn;
          } else if (tmp === 'mun_red_desplazada') {
            newFeature.tipo_name = 'Municipio red desplazada';
            newFeature.desc = feature.properties.nombre_municipio_ine;
          } else if (tmp === 'territorio_gn') {
            newFeature.tipo_name = 'Zona NO NEDGIA';
            newFeature.desc = feature.properties.nombre_municipio_ine + ', ' + feature.properties.nombre_provincia_ine;
          } else if (tmp === 'comercial') {
            if (feature.properties.id_categoria_gn_comercial.id) {
              newFeature.tipo_name = 'Comercial (' + feature.properties.id_categoria_gn_comercial.categoria_gn_comercial + ')';
            } else {
              tmpType = this.ComercialTypes.filter(e => e.id === feature.properties.id_categoria_gn_comercial)[0];
              newFeature.tipo_name = 'Comercial (' + tmpType.categoria_gn_comercial + ')';
            }
            if (feature.properties.nombre) {
              newFeature.desc = '<strong>' + feature.properties.nombre + '</strong>';
              if (feature.properties.direccion_no_estructurada) {
                newFeature.desc = newFeature.desc + ' - ' + feature.properties.direccion_no_estructurada;
              }
            } else {
              newFeature.desc = feature.properties.tipo_via + ' ' + feature.properties.nombre_via + ' ' + feature.properties.numero;
              if (feature.properties.anexo) {
                newFeature.desc = newFeature.desc + ' ' + feature.properties.anexo;
              }
              newFeature.desc = newFeature.desc + ' (' + feature.properties.poblacion + ')';
            }
          } else if (tmp === 'caldera') {
            newFeature.tipo_name = 'Caldera centralizada';

            this.idCalderasCentralizadas.push(feature.id.split('.')[1]);

            newFeature.desc = feature.properties.tipo_via + ' ' + feature.properties.nombre_via + ' ' + feature.properties.numero;
            if (feature.properties.anexo) {
              newFeature.desc = newFeature.desc + ' ' + feature.properties.anexo;
            }
            newFeature.desc = newFeature.desc + ' - ' + feature.properties.codigo_postal + ' ' + feature.properties.poblacion + ' ' + feature.properties.municipio + ' (' + feature.properties.provincia + ')';
          } else if (tmp === 'residencial_unifamiliar') {
            newFeature.tipo_name = 'Residencial Unifamiliar';
            newFeature.desc = feature.properties.name_type + ' ' + feature.properties.street_name + ' ' + feature.properties.building_number;
            if (feature.properties.additional_annex) {
              newFeature.desc = newFeature.desc + ' ' + feature.properties.additional_annex;
            }
            newFeature.desc = newFeature.desc + ' - ' + feature.properties.nombre_poblacion_zeus + ' ' + feature.properties.nombre_municipio_zeus + ' (' + feature.properties.nombre_provincia_zeus + ')';
          } else if (tmp === 'residencial_bifamiliar') {
            newFeature.tipo_name = 'Residencial Bifamiliar';
            newFeature.desc = feature.properties.name_type + ' ' + feature.properties.street_name + ' ' + feature.properties.building_number;
            if (feature.properties.additional_annex) {
              newFeature.desc = newFeature.desc + ' ' + feature.properties.additional_annex;
            }
            newFeature.desc = newFeature.desc + ' - ' + feature.properties.nombre_poblacion_zeus + ' ' + feature.properties.nombre_municipio_zeus + ' (' + feature.properties.nombre_provincia_zeus + ')';
          } else if (tmp === 'residencial_plurifamiliar') {
            newFeature.tipo_name = 'Residencial Plurifamiliar';
            newFeature.desc = feature.properties.name_type + ' ' + feature.properties.street_name + ' ' + feature.properties.building_number;
            if (feature.properties.additional_annex) {
              newFeature.desc = newFeature.desc + ' ' + feature.properties.additional_annex;
            }
            newFeature.desc = newFeature.desc + ' - ' + feature.properties.nombre_poblacion_zeus + ' ' + feature.properties.nombre_municipio_zeus + ' (' + feature.properties.nombre_provincia_zeus + ')';
          } else if (tmp === 'seccion_censal') {
            newFeature.tipo_name = 'Seccion Censal';
            newFeature.desc = feature.properties.codigo_seccion_censal;
          } else if (tmp === 'codigo_postal') {
            newFeature.tipo_name = 'Código postal';
            newFeature.desc = feature.properties.codigo_postal;
          } else if (tmp === 'nucleo_urbano') {
            newFeature.tipo_name = 'Núcleo urbano';
            newFeature.desc = feature.properties.nombre_provincia_ine + ' (' + feature.properties.codigo_municipio_ine + ')';
          } else {
            newFeature.tipo_name = tmp;
            newFeature.desc = '';
          }
        }
        if (list.findIndex(e => e.id === newFeature.id) === -1) {
          list.push(newFeature);
        }
      }

      list.sort(function (vote1, vote2) {
        if (vote1.tipo_name > vote2.tipo_name) return 1;
        if (vote1.tipo_name < vote2.tipo_name) return -1;

        if (vote1.desc.replace(/<[/]?strong>/g, '') > vote2.desc.replace(/<[/]?strong>/g, '')) return 1;
        if (vote1.desc.replace(/<[/]?strong>/g, '') < vote2.desc.replace(/<[/]?strong>/g, '')) return -1;
      });

      let promises = this.idCalderasCentralizadas.map(id => this.$http.get('caldera_extendida/' + id + '/'));

      let promisesFinished = false;

      if (promises.length > 0) {
        Promise.all(promises).then(r => {
          for (let rIndex = 0; rIndex < r.length; rIndex++) {
            try {
              const element = r[rIndex].data;

              let calderaCentralizada = element.caldera_centralizada;

              let listIndex = list.findIndex(z => z.id === 'caldera.' + element.id);
              if (listIndex > -1) {
                list[listIndex].tipo_name = 'Caldera centralizada (' + calderaCentralizada + ')';
              }
            } catch (error) {
              console.log(error);
            }
          }

          promisesFinished = true;
        });

        this.interval = setInterval(() => {
          if (promisesFinished) {
            clearInterval(this.interval);
            this.parsedFeatures = list;
            cb();
          }
        }, 500);
      } else {
        this.parsedFeatures = list;
        cb();
      }
    },
    close: function () {
      this.$refs.myModal.hide();
    },
    getDetailsIfLoaded: function () {
      this.calcParsedFeatures(() => {
        if (this.parsedFeatures.length === 1) {
          this.showDetails(this.parsedFeatures[0]);
        } else if (this.parsedFeatures.length === 0) {
          this.$refs.myModal.hide();
        }
      });
    },
    comercialSaved: function () {
      this.$emit('comercialSaved');
    },
    calderaSaved: function () {
      this.$emit('calderaSaved');
    },
    saveLocation: function () {
      var latlng = this.$parent.modLayer.getLatLng();
      this.$refs.details.$refs.cambios.setLocation(latlng);
      this.atras();
    },
    atras: function () {
      this.localizado = false;
      this.change = false;
      this.$parent.map.map.removeLayer(this.$parent.modLayer);
    },
    changeLocation: function (modification) {
      // console.log('test')
      this.localizado = true;
      this.change = true;
      if (modification.longitud) {
        this.$emit('changeLocation', {geometry: {coordinates: [modification.longitud, modification.latitud]}});
      } else {
        this.$emit('changeLocation', this.details);
      }
    },
    localizar: function () {
      this.localizado = true;
      this.$emit('setLocation');
    },
    localizar2: function (modification = null) {
      this.localizado = true;
      this.$emit('getLocation', modification);
    },
    hasPermision: function (group, p) {
      if (group === 'caldera') {
        return this.$parent.permisos['CALDERA CENTRALIZADA'][p];
      } else if (group === 'comercial') {
        return this.$parent.permisos['COMERCIAL'][p];
      } else {
        if (group.name === 'Territorio') {
          return (this.$parent.permisos['TERRITORIO GN'][p] || this.$parent.permisos['TERRITORIO NO GN'][p]);
        } else {
          if (group.rol) {
            return this.$parent.permisos[group.rol][p];
          } else {
            return false;
          }
        }
      }
    },
    onHidden: function () {
      this.details = false;
      this.$emit('hide');
      // this.$parent.showPopUp = false
    },
    showDetails: function (row) {
      this.loadingDetails = true;

      // Obtenemos el tipo, el id y la geometria
      const type = row.id.split('.')[0];
      const id = row.id.split('.')[1];
      this.geometry = row.geometry;

      if (type === 'comercial') {
        this.$http.get('comercial/' + id + '/').then(result => {
          row.properties = result.data;
          this.details = row;
          this.modalTitle = this.getTitle(this.details);
          this.loadingDetails = false;
        });
      } else if (type === 'caldera') {
        this.$http.get('caldera/' + id + '/').then(result => {
          row.properties = result.data;
          this.details = row;
          this.modalTitle = this.getTitle(this.details);
          this.loadingDetails = false;
        });
      } else if (type === 'residencial_unifamiliar' || type === 'residencial_bifamiliar' || type === 'residencial_plurifamiliar') {
        this.$http.get('residencial/' + id + '/').then(result => {
          row.properties = result.data;
          this.details = row;
          this.modalTitle = this.getTitle(this.details);
          this.loadingDetails = false;
        });
      } else {
        this.details = row;
        this.modalTitle = this.getTitle(this.details);
        this.loadingDetails = false;
      }
      if (this.territorieslayer.find(territory => territory === type)) {
        this.isTerritory = true;
      }

      // Llamamos al evento de "App.vue" para cargar la capa selectedLayer con la geometria
      this.$emit('clickFeature', row);
    },
    noDetails: function () {
      this.details = false;
      this.modalTitle = 'Seleccione elemento';
    },
    getTitle: function (feature) {
      if (!feature.catastro) {
        var type = feature.id.split('.')[0];
      } else {
        return 'Parcela catastro';
      }

      if (type === 'red') {
        return 'Subtramo Red';
      } else if (type === 'red_inyeccion') {
        return 'Red inyección biogás';
      } else if (type === 'provincia') {
        return 'Provincia';
      } else if (type === 'zona_gn') {
        return 'Área GN';
      } else if (type === 'municipio') {
        return 'Municipio';
      } else if (type === 'mun_red_desplazada') {
        return 'Municipio red desplazada';
      } else if (type === 'codigo_postal') {
        return 'Código postal';
      } else if (type === 'comercial') {
        return 'Comercial';
      } else if (type === 'caldera') {
        return 'Caldera';
      } else if (type === 'territorio_gn') {
        return 'Zonas NO NEDGIA';
      } else if (type === 'territorio_gn_canon_irc') {
        return 'Zona exención IRC';
      } else if (type === 'territorio_gn_derechos_alta') {
        return 'Zona exención alta';
      } else if (type === 'residencial_unifamiliar') {
        return 'Residencial Unifamiliar';
      } else if (type === 'residencial_bifamiliar') {
        return 'Residencial Bifamiliar';
      } else if (type === 'residencial_plurifamiliar') {
        return 'Residencial Plurifamiliar';
      } else if (type === 'seccion_censal') {
        return 'Seccion Censal';
      } else if (type === 'nucleo_urbano') {
        return 'Núcleo urbano';
      }
    },
    selectArea () {
      this.$emit('selectedArea', this.geometry);
      this.geometry = null;
      this.onHidden();
    },
    getFeaturesCatastro: function () {
      return new Promise(async (resolve, reject) => {
        const paramsCatastro = {
          request: 'GetFeatureInfo',
          service: 'WMS',
          FORMAT: 'image/png',
          bbox: this.$parent.map.map.getBounds().toBBoxString(),
          height: this.$parent.map.map.getSize().y,
          width: this.$parent.map.map.getSize().x,
          query_layers: 'PARCELA',
          x: this.clickEvent.containerPoint.x.toFixed(0),
          y: this.clickEvent.containerPoint.y.toFixed(0),
          srs: 'EPSG:4326'
        };

        // Get catastro data (url + code)
        let response = await this.$http.post('catastro_feature/', {'url': 'http://ovc.catastro.meh.es/Cartografia/WMS/ServidorWMS.aspx' + self.L.Util.getParamString(paramsCatastro)});
        if (response.body.error) {
          reject(`Error obteniendo el código y url del catastro`);
          return;
        } else if (!response.data.code) {
          resolve([]);
          return;
        }

        // Montamos la feature con los datos del catastro
        const feature = {
          id: `catastro.${response.data.code}`,
          catastro: true,
          code: response.data.code,
          url: response.data.url
        };

        // Get geometry from catastro web
        const url = 'http://ovc.catastro.meh.es/ovcservweb/ovcswlocalizacionrc/ovccoordenadas.asmx/Consulta_CPMRC';
        const paramsCoordinates = {Provincia: '', Municipio: '', RC: feature.code, SRS: 'EPSG:4326'};
        response = await this.$http.post('refcatastral/', {'url': url + self.L.Util.getParamString(paramsCoordinates)});
        if (response.body.error) {
          reject(`Error recuperando las coordenadas del catastro`);
          return;
        }

        // Añadimos la geometria a los datos del catastro
        const coordinates = [parseFloat(response.body.x), parseFloat(response.body.y)];
        feature['geometry'] = {coordinates: coordinates, type: 'Point'};
        resolve([feature]);
      });
    },
    getFeatureWMS: function (layersList, cqlList) {
      return new Promise((resolve, reject) => {
        const urlWMS = process.env.URL_WMS;
        const params = {
          request: 'GetFeatureInfo',
          service: 'WMS',
          srs: 'EPSG:4326',
          bbox: this.$parent.map.map.getBounds().toBBoxString(),
          height: this.$parent.map.map.getSize().y,
          width: this.$parent.map.map.getSize().x,
          layers: layersList,
          query_layers: layersList,
          info_format: 'application/json',
          x: this.clickEvent.containerPoint.x.toFixed(0),
          y: this.clickEvent.containerPoint.y.toFixed(0),
          exceptions: 'application/json',
          feature_count: 100,
          version: '1.1.0',
          CQL_FILTER: cqlList.join(';')
        };

        self.$.ajax({
          url: urlWMS + self.L.Util.getParamString(params, urlWMS, true),
          success: function (data, status, xhr) {
            const features = data.features || [];
            resolve(features);
          },
          error: function (xhr, status, error) {
            reject(error.exceptions[0].text);
          }
        });
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Map/PopUp.vue